import { Link } from 'react-router-dom';

const Footer = () => {
  const scrollToSection = (hash: string) => {
    const element = document.querySelector(hash);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-primary text-white">
      <div className="container mx-auto px-4 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img
              src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/cec408eade00b7f2bb8d035c2ad6c56f.png"
              alt="Rawafi Al Mutahidun"
              className="h-20 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-white/80 font-inter text-sm leading-relaxed mb-4">
              Leading crane rental and heavy equipment provider in Saudi Arabia with over 15 years of experience.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white hover:text-accent transition-all duration-300 cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white hover:text-accent transition-all duration-300 cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white hover:text-accent transition-all duration-300 cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white hover:text-accent transition-all duration-300 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Cranes */}
          <div>
            <h3 className="text-lg font-poppins font-bold mb-6">Cranes</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/cranes/heavy"
                  className="text-white/80 hover:text-white font-inter text-sm transition-colors duration-300 cursor-pointer"
                >
                  Heavy Cranes (25-300 tons)
                </Link>
              </li>
              <li>
                <Link
                  to="/cranes/light"
                  className="text-white/80 hover:text-white font-inter text-sm transition-colors duration-300 cursor-pointer"
                >
                  Light Cranes (3-19 tons)
                </Link>
              </li>
            </ul>
          </div>

          {/* Equipment */}
          <div>
            <h3 className="text-lg font-poppins font-bold mb-6">Equipment</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/equipment/flatbed"
                  className="text-white/80 hover:text-white font-inter text-sm transition-colors duration-300 cursor-pointer"
                >
                  Flatbeds
                </Link>
              </li>
              <li>
                <Link
                  to="/equipment/manlift"
                  className="text-white/80 hover:text-white font-inter text-sm transition-colors duration-300 cursor-pointer"
                >
                  Manlift
                </Link>
              </li>
              <li>
                <Link
                  to="/equipment/forklift"
                  className="text-white/80 hover:text-white font-inter text-sm transition-colors duration-300 cursor-pointer"
                >
                  Forklift
                </Link>
              </li>
              <li>
                <Link
                  to="/equipment/scissor-lift"
                  className="text-white/80 hover:text-white font-inter text-sm transition-colors duration-300 cursor-pointer"
                >
                  Scissor Lift
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-poppins font-bold mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-1">
                  <i className="ri-map-pin-line text-lg"></i>
                </div>
                <span className="text-white/80 font-inter text-sm">
                  Riyadh, Saudi Arabia
                </span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-1">
                  <i className="ri-phone-line text-lg"></i>
                </div>
                <a
                  href="tel:+966123456789"
                  className="text-white/80 hover:text-white font-inter text-sm transition-colors duration-300 cursor-pointer"
                >
                  +966 12 345 6789
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-1">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <a
                  href="mailto:info@rawafi.com"
                  className="text-white/80 hover:text-white font-inter text-sm transition-colors duration-300 cursor-pointer"
                >
                  info@rawafi.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/60 font-inter text-sm text-center md:text-left">
              © 2024 Rawafi Al Mutahidun. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link
                to="/about"
                className="text-white/60 hover:text-white font-inter text-sm transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                About Us
              </Link>
              <a
                href="/#contact"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('#contact');
                }}
                className="text-white/60 hover:text-white font-inter text-sm transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                Contact
              </a>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 hover:text-white font-inter text-sm transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                Powered by AAIT
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
